export default (state, { id }) => state.user
  && state.user.data
  && state.user.data.userGroupRelations.find((relation) => relation.id === id)
